<div class="cookie">
  <div class="row montserrat">
      <div class="cookiecontent float-right col-6 cookietext">
          <!-- This site uses cookies to improve your browsing experience. <a href="./cookie" target="_blank">Read more</a> -->
      </div>
      
      <div class="float-right col-6">
          <div class="btn btn-secondary cookie-compliance float-right"></div>
      </div>
  </div>
</div>

<app-nav></app-nav>
<router-outlet></router-outlet>
<app-footer></app-footer>